import { Outlet } from 'react-router-dom'
import { styled, useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

import Header from './components/Header'

const Body = styled('main')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
  height: '100vh',
  width: '100vw',
  overflow: 'hidden',

  '@supports (height: 100dvh)': {
    height: '100dvh',
  },
}))

export default function ProtectedLayout() {
  const theme = useTheme()
  const mobileView = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Body>
      {!mobileView && <Header />}
      <Outlet />
      {mobileView && <Header />}
    </Body>
  )
}
